import { useContext, useRef, useEffect, useState } from "react";
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerJurados } from "../components/BannerJurados";
import { TextoInicialJurados } from "../components/TextoInicialJurados";
import { Footer } from "../../../components/Landing/Footer";
import { TextoinicialNumero } from "../components/TextoinicialNumero";
import { Row, Col, Input, Button, Form, Table, Empty, Modal, Popover, Divider } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useDocAdministrativosJurados } from "../../../hooks/useDocAdministrativosJurados";
import { useDocumentosAdministrativos } from "../../../hooks/useDocumentosAdministrativos";
import { DownloadFile } from "../../../utils/DownloadFile";
import { useReactToPrint } from "react-to-print";
import { TemplateContext } from "../../../utils/template_context";
import DocumentInput from "../../../utils/DocumentInput";
import { useNavigate } from "react-router-dom";
import { UseVerConvocatorias } from "../../../hooks/UseVerConvocatorias";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import { useEncrypt } from "../../../hooks/useEncrypt";

export const DocumentosAdministrativosJurado = () => {
  const renderNavigate = useNavigate();
  const {
    getConvocatoriaPersistente,
    convocatoriaPersitente: convocatoria,
    setConvocatoriaPersitente,
    descargarArchivo,
  } = UseVerConvocatorias();
  const {
    openModal,
    setOpenModal,
    continuarDocAdm,
  } = useDocAdministrativosJurados();
  const {
    eliminarArchivo,
    consultarArchivos,
    cargarPostulacionTipoParticipante,
    guardarArchivosAdministrativos,
    documentos,
    setDocumentos,
    loading,
  } = useDocumentosAdministrativos();
  const context = useContext(TemplateContext);
  const AceptarModal = () => {
    setOpenModal(false);
  };
  const componentRef = useRef<any>();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle:
      "pageStyles={'@media print { body { -webkit-print-color-adjust: exact; } @page { size: A4; margin: 200mm !important }}'}",
  });

  const { decrypt } = useEncrypt();
  const [documentosusuario, setDocumentosUsuario] = useState<any>([]);

  useEffect(() => {
    if (documentos.length > 0) {
      let nuevosdocumentos = documentos;
      nuevosdocumentos.map((documento) => {
        if (documentosusuario && documentosusuario.length > 0 && documento.url_participante === undefined) {
          const filterDocumentoAdministrativo = documentosusuario.filter((documentoAdministrativo) => documento.id == documentoAdministrativo.id);
          documento.url_participante = filterDocumentoAdministrativo[0] && filterDocumentoAdministrativo[0].url_participante !== "" ? filterDocumentoAdministrativo[0].url_participante : documento.url_participante;
        }
        return documento;
      });
      setDocumentos(nuevosdocumentos)
    }
  }, [documentosusuario, documentos]);

  return (
    <div>
      <Header />
      <BannerJurados BannerText="Banco de Jurados - Asociar documentación administrativa" convocatorias={convocatoria}/>

      <div className="container-fluid2">
        <TextoInicialJurados
          TituloSpan="Agrega documentación administrativa."
          TitulosinSpan=""
        />
      </div>

      <div className="container-fluid2">
        <div className="col-12 p-2">
          <div className="row">
            <TextoinicialNumero
              numero="9"
              textosinspan="Agregar documentación administrativa"
              textospan="Todos los campos son obligatorios"
              color="morado"
            />
          </div>
        </div>
      </div>

      <div className="container-fluid2">
        <div className="row mt-4 mb-5">
          {documentos.map((data: any, index: number) => (
            <>
              <div className="col-12 col-md-6 col-lg-4 mt-3 mb-2">
                <div className="row m-0 cards-documentos">
                  <div className="col-12 mb-3 font-family-Montserrat-Bold font-size-14px">
                    {data.tipo_documento}
                  </div>
                  <div className="col-12 font-family-Montserrat-Regular font-size-14px">
                    {!data.url_participante && data.descripcion}
                  </div>
                  <div className="col d-flex">
                    {data.url_documento ? (
                      <Button
                        className="button-yellow-ghost"
                        style={{ paddingLeft: "0" }}
                        onClick={() => {
                          DownloadFile(
                            data.url_documento
                          );
                        }}
                      >
                        DESCARGAR FORMATO
                      </Button>
                    ) : (
                      <div
                        className=""
                        style={{ color: "#ff8900", marginTop: "25px" }}
                      >
                        SIN FORMATO
                      </div>
                    )}
                  </div>
                  <div className="col justify-content-flex-end">
                    <Button
                      className="button-gray-ghost pe-0 pb-0 m-0 mt-4"
                      onClick={() => {
                        let inputs: HTMLElement =
                          document.getElementsByClassName("inputs-ref")[
                          index
                          ] as HTMLElement;
                        inputs.click();
                      }}
                    >
                      CARGAR DOCUMENTO
                    </Button>
                    <input
                      className="inputs-ref"
                      type="file"
                      hidden
                      onChange={async (e) => {
                        guardarArchivosAdministrativos(data, e, index);
                        e.target.value = "";
                      }}
                    />
                  </div>
                  {data.url_participante && data.url_participante !== "" ? (
                    <div className="row m-0 background-color-00904C position-absolute-card-documento">
                      <div className="col-8 text-white">{data.descripcion}</div>
                      <div className="col-4 justify-content-flex-end text-white font-size-24px">
                        <CheckCircleOutlined />
                      </div>
                      <div
                        id="tipo_doc"
                        className="col-10 mb-3 font-family-Montserrat-Bold font-size-14px font-color-FFFFFF"
                      >
                        {data.tipo_documento}
                      </div>
                      <div className="col-6 justify-content-flex-end">
                        <Button
                          className="button-blanco-ghost text-uppercase font-family-Montserrat-Regular"
                          style={{ paddingLeft: "0" }}
                          onClick={(e) => {
                            const filterDoc = documentosusuario.filter((documentoAdmin) => documentoAdmin.id !== data.id);
                            setDocumentosUsuario(filterDoc);
                            eliminarArchivo(e, index, data.id)
                          }
                          }
                        >
                          Eliminar
                        </Button>
                      </div>
                      <div className="col-6">
                        <Button className="button-blanco-ghost font-family-Montserrat-Bold text-uppercase">
                          Cargado
                        </Button>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
      <div
          className="container-fluid2 bg-white"
          style={{
            justifyContent: "center",
            position: "sticky",
            bottom: 0,
            paddingBottom: "0%",
          }}
        >
          <div className="col justify-content-flex-end">
            <Button className="button-blanco-radius font-size-12px" style={{ marginRight: "16px" }} onClick={() => { return renderNavigate('/usuario/Reconocimientos') }}>Atrás</Button>
            <Button
              className="button-azul-radius font-size-12px"
              onClick={() => continuarDocAdm()}
            >
              Continuar
            </Button>
          </div>
        </div>
      <Footer />
      <div>
        <Modal
          style={{ top: 20, zIndex: 3, background: "transparent" }}
          visible={openModal}
          cancelButtonProps={{ style: { display: "none" } }}
          okButtonProps={{ style: { display: "none" } }}
          closable={false}
          closeIcon=""
          width={662}
          maskStyle={{
            zIndex: 3,
            background: "rgba(0,144,76,0.8)",
          }}
          className="modal-postulacion-exitosa"
        >
          <div className="row-shadow">
            <div className="row">
              <div className="col-12 font-size-22px font-family-Montserrat-Bold justify-content-center">
                Se ha completado el proceso
              </div>
              <div className="col-12 font-size-16px font-family-Montserrat-Regular justify-content-center">
                Felicidades te has postulado con éxito en la convocatoria:
              </div>
              <div className="col-12 font-size-16px font-family-Montserrat-SemiBold justify-content-center">
                Puede hacerle seguimiento desde el menú "Mis proyectos"
              </div>
            </div>
            <div className="row">
              <div
                className="justify-content-flex-end"
                style={{ paddingRight: "8px" }}
              >
                <Button className="button-blanco-radius" onClick={handlePrint}>
                  Descargar
                </Button>
              </div>
              <div
                className="justify-content-flex-end"
                style={{ textAlign: "initial", paddingLeft: "8px" }}
              >
                <Button className="button-azul-radius" onClick={AceptarModal}>
                  Aceptar
                </Button>
              </div>
            </div>
          </div>
          <div className="row-shadow">
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-12">
                    Código radicado:
                    <Divider />
                  </div>
                  <div className="col-12">
                    Nombre representante:
                    <Divider />
                  </div>
                  <div className="col-12">
                    Nombre del proyecto:
                    <Divider />
                  </div>
                  <div className="col-12">
                    Cédula/NIT:
                    <Divider />
                  </div>
                  <div className="col-12">
                    Fecha:
                    <Divider />
                  </div>
                  <div className="col-12">
                    Línea:
                    <Divider />
                  </div>
                  <div className="col-12">
                    Tipo participante:
                    <Divider />
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-12">
                    <Divider />
                  </div>
                  <div
                    className="col-12"
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    <Divider />
                  </div>
                  <div
                    className="col-12"
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    <Divider />
                  </div>
                  <div
                    className="col-12"
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    <Divider />
                  </div>
                  <div
                    className="col-12"
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    <Divider />
                  </div>
                  <div
                    className="col-12"
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    <Divider />
                  </div>
                  <div className="col-12">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};
